document.addEventListener('DOMContentLoaded', () => {
    const whatsappLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[data-wa]');
    whatsappLinks.forEach(link => {

        link.addEventListener('focus', decodeLink);
        link.addEventListener('touchstart', decodeLink);
        link.addEventListener('click', decodeLink);
    });

    function decodeLink(event) {
        event.preventDefault();
        const link: HTMLAnchorElement = event.currentTarget;

        setTimeout(() => {
            link.href = atob(link.dataset.wa);

            link.removeEventListener('focus', decodeLink);
            link.removeEventListener('touchstart', decodeLink);
            link.removeEventListener('click', decodeLink);

            link.click();
        }, 300);
    }
});
